// extracted by mini-css-extract-plugin
export default {"player":"player__9F4Ba","audio":"audio__6ZNnl"};